<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        Audits | Quality Assurance
      </h2>
      <div class="flex space-x-4">
        <div class="flex space-x-2">
          <HashtagIcon class="mt-1.5 h-6 w-6 text-gray-500" />
          <input v-model="order" type="text" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" placeholder="Search an order number" />
        </div>
        <div class="flex space-x-2">
          <UserIcon class="mt-1.5 h-6 w-6 text-gray-500" />
          <input v-model="name" type="text" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" placeholder="Search a name" />
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <table class="table">
      <thead>
      <tr>
        <th>Order</th>
        <th class="hidden lg:table-cell">Status</th>
        <th class="hidden sm:table-cell">User</th>
        <th>Happened At</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="audits.data.length" v-for="audit in audits.data">
        <tr>
          <td class="w-full max-w-0 text-gray-900 sm:w-auto sm:max-w-none">
            <a href="#">{{ audit.order_number }}</a>
            <dl class="font-normal lg:hidden">
              <dt class="sr-only">Status</dt>
              <dd class="mt-1 truncate text-gray-700">{{ audit.status }}</dd>
              <dt class="sr-only sm:hidden">User</dt>
              <dd class="mt-1 truncate text-gray-500 sm:hidden">
                <a href="#">{{ audit.user_name }}</a>
              </dd>
            </dl>
          </td>
          <td class="hidden text-gray-500 lg:table-cell">
            {{ audit.status }}
          </td>
          <td class="hidden text-gray-500 sm:table-cell">
            <a href="#">{{ audit.user_name }}</a>
          </td>
          <td>
            {{ audit.happened_at }}
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="4" class="text-center">No quality assurance audits recorded</td>
        </tr>
      </template>
      </tbody>
    </table>

    <div class="card-footer">
      <Pagination v-bind:pagination="audits" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { HashtagIcon, UserIcon } from "@heroicons/vue/24/outline";
import useDebouncedRef from "../../composables/Debounce";
import Pagination from "../../components/Pagination";
import { router, usePage } from "@inertiajs/vue3";

const { audits } = defineProps(['audits']);
const props = usePage().props;

const order = useDebouncedRef(props.order, 400);
const name = useDebouncedRef(props.name, 400);

watch(order, value => {
  let data = {
    order: value
  };

  if (name.value) {
    data.name = name.value
  }

  if (!value) {
    delete data.order;
  }

  router.get(route('audits.qa.index'), data, {
    preserveState: true,
  });
});

watch(name, value => {
  let data = {
    name: value
  };

  if (order.value) {
    data.order = order.value
  }

  if (!value) {
    delete data.name;
  }

  router.get(route('audits.qa.index'), data, {
    preserveState: true,
  });
});

</script>
